@if (show) {
  <div class="init-sign-in-container">
    <!-- // BACKGROUND SHAPES -->
    <div class="absolute-watermark absolute-watermark--money-plus">
      <svg-icon
        src="assets/icons/plus-money.svg"
        [svgStyle]="{ 'width.px':300, 'height.px':300 }"
      ></svg-icon>
    </div>
    <div class="absolute-watermark absolute-watermark--chart">
      <svg-icon
        src="assets/icons/watermark-chart.svg"
        [svgStyle]="{ 'width.px':300, 'height.px':300 }"
      ></svg-icon>
    </div>
    <!-- // COMMON -->
    <h1 class="mb-0 z-index-2">{{ 'modal.initSignIn.common.title' | translate }}</h1>
    <h2 class="px-sm-5 z-index-2">{{ 'modal.initSignIn.common.subtitle' | translate }}</h2>
    <div class="py-2 z-index-2">{{ 'modal.initSignIn.common.info' | translate }}</div>
    <!-- // USER ALREADY HAS CREATED A PORTFOLIO OR STRATEGY -->
    @if (hasPortfolioOrStrategy) {
      <div class="has-portfolio">
        <div class="how-to py-3">{{ 'modal.initSignIn.common.howToQuestion' | translate }}</div>
        <div class="shadow-container has-portfolio-items">
          <div class="item">
            <svg-icon class="item-image" src="assets/icons/watermark-chart-2.svg" [svgStyle]="{ 'width.px':31, 'height.px':31}"></svg-icon>
            <div>
              {{ 'modal.initSignIn.hasPortfolio.text1a' | translate }}<strong>{{ 'modal.initSignIn.hasPortfolio.text1b' | translate }}</strong><br />
              <span class="green"><strong>{{ 'modal.initSignIn.hasPortfolio.text1c' | translate }}</strong></span>
              <img src="assets/images/temp/mark-circle.png" class="mark-circle-icon" alt="yes checkmark" />
            </div>
          </div>
          <div class="item">
            <svg-icon class="item-image" src="assets/icons/money-pile.svg" [svgStyle]="{ 'width.px':33, 'height.px':33 }"></svg-icon>
            <div class="pt-2">
              {{ 'modal.initSignIn.hasPortfolio.text2a' | translate }}<strong>{{ 'modal.initSignIn.hasPortfolio.text2b' | translate }}</strong>
            </div>
          </div>
          <div class="item">
            <svg-icon class="item-image" src="assets/icons/plus-money.svg" [svgStyle]="{ 'width.px':40, 'height.px':40 }"></svg-icon>
            <div class="pt-2">
              <strong>{{ 'modal.initSignIn.hasPortfolio.text3a' | translate }}</strong>
              <span
                class="add-money-link green"
                (click)="onAddMoneyClick()"
                (keydown.space)="onAddMoneyClick()"
                (keydown.enter)="onAddMoneyClick()"
                tabindex="0"
                >
                {{ 'modal.initSignIn.hasPortfolio.text3b' | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="no-portfolio">
        <div class="shadow-container no-portfolio-items mt-3">
          <div class="how-to pb-3">{{ 'modal.initSignIn.common.howToQuestion' | translate }}</div>
          <div class="description-1 pb-3">
            {{ 'modal.initSignIn.noPortfolio.text1a' | translate }}<strong>{{ 'modal.initSignIn.noPortfolio.text1b' | translate }}</strong>
          </div>
          <div class="description-2 px-md-3 px-lg-5 pb-2">
            <strong>{{ 'modal.initSignIn.noPortfolio.text2' | translate }}</strong>
          </div>
          <div class="portfolio-types">
            @for (idx of getPortfolioTypesIdxsByMax(maxRiskScore); track idx) {
              <span class="type">
                {{ 'profile.portfolioTypes.' + idx | translate }}
              </span>
            }
          </div>
          <div class="description-3 pt-4 pb-2">
            {{ 'modal.initSignIn.noPortfolio.text3a' | translate }}<strong>{{ 'modal.initSignIn.noPortfolio.text3b' | translate }}</strong>
          </div>
        </div>
        <div class="create-portfolio-container mt-3" [ngClass]="{'pb-3': !hasStrategiesAccess}">
          <div class="heading mb-4">
            {{ 'modal.initSignIn.noPortfolio.text4a' | translate }}<br />
            {{ 'modal.initSignIn.noPortfolio.text4b' | translate }}
          </div>
          <libero-button
            label="{{ 'modal.initSignIn.noPortfolio.createModelPortfolio' | translate }}"
            btnClasses="btn--primary btn--big"
            (click)="onAddNewPortfolioClick()"
          ></libero-button>
        </div>
        @if (hasStrategiesAccess) {
          <div class="create-strategy-container" [ngClass]="{'pb-3': hasStrategiesAccess}">
            <div class="heading">
              {{ 'modal.initSignIn.noPortfolio.text5a' | translate }}
              <strong>{{ 'modal.initSignIn.noPortfolio.text5b' | translate }}</strong>
              {{ 'modal.initSignIn.noPortfolio.text5c' | translate }}
            </div>
            <libero-button
              label="{{ 'modal.initSignIn.noPortfolio.createStrategy' | translate }}"
              btnClasses="btn--primary btn--big"
              (click)="onAddNewStrategyClick()"
            ></libero-button>
          </div>
        }
      </div>
    }
    <!-- // USER HAS NOT YET CREATED A PORTFOLIO OR STRATEGY -->
    <!-- // COMMON -->
    <div class="common-footer">
      <div class="need-consultation">
        {{ 'modal.initSignIn.common.needConsultant1' | translate }}<br />
        {{ 'modal.initSignIn.common.needConsultant2' | translate }}
      </div>
      <libero-button
        label="{{ 'modal.initSignIn.common.confirmConsultation' | translate }}"
        btnClasses="btn--primary btn--heading mt-4 mb-5 z-index-2"
        (click)="onConsultClick()"
      ></libero-button>
      <div class="disclaimer pb-4 px-3">
        {{ 'modal.initSignIn.common.disclaimer' | translate }}
      </div>
    </div>
  </div>
}

